<template>
  <div class="outer bg">
    <div class="inner behind"></div>
    <div class="shadow masters"></div>
    <div class="inner front"></div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="less" scoped>
@import '~@npm/@gd/common-styles/lib/color-vars';
.bg {
  background: #6a2328 url('../../assets/romme/romme_bg_pattern.jpg');
}
</style>
